import React from 'react';

import {DocTableCell} from './DocTableCell';

import './DocTableRow.scss';

interface DocTableRowProps {
    cells: string[];
    bold?: boolean;
}

export const DocTableRow: React.FC<DocTableRowProps> = ({cells, bold = false}) => (
        <div className={"doc-table-row" + (bold ? ' bold' : '')}>
            {cells.map((value, index) => (
                    <DocTableCell key={`key-doc-table-row-cell-${index + 1}`}>{value}</DocTableCell>
            ))}
        </div>
);
